export async function currentSessionToken() {
    let token = localStorage.getItem('authToken');
    if (token) {
        return {  'Access-Control-Allow-Origin' : '*','Authorization': `Bearer ${token}` };
    } else {
        return {  'Access-Control-Allow-Origin' : '*' };
    }
}